import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <div className="flex flex-col leading-none cursor-pointer" onClick={() => scrollTo('hero')}>
          <span
            className={`font-serif text-xl md:text-2xl font-medium tracking-wide transition-colors duration-300 ${
              scrolled ? 'text-ink' : 'text-white'
            }`}
          >
            Nail Studio
          </span>
          <span
            className={`font-sans text-xs tracking-widest2 uppercase transition-colors duration-300 ${
              scrolled ? 'text-gold' : 'text-gold-light'
            }`}
          >
            by Daniela
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Services', id: 'features' },
            { label: 'Gallery', id: 'gallery' },
            { label: 'Pricing', id: 'pricing' },
            { label: 'About', id: 'how-it-works' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`font-sans text-sm tracking-wider uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-ink-soft hover:text-gold' : 'text-white/80 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://www.instagram.com/nailstudiobydaniela"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-8 h-8 flex items-center justify-center transition-colors duration-300 cursor-pointer ${
              scrolled ? 'text-ink-soft hover:text-gold' : 'text-white/80 hover:text-white'
            }`}
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
          <button
            onClick={() => window.open('https://calendly.com/lispinruiz/nailappointment', '_blank')}
            className="whitespace-nowrap font-sans text-sm tracking-wider uppercase px-6 py-2.5 border border-gold text-gold hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer"
          >
            Book Now
          </button>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl ${scrolled ? 'text-ink' : 'text-white'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-sm border-t border-blush-mid px-6 py-6 flex flex-col gap-5">
          {[
            { label: 'Services', id: 'features' },
            { label: 'Gallery', id: 'gallery' },
            { label: 'Pricing', id: 'pricing' },
            { label: 'About', id: 'how-it-works' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="font-sans text-sm tracking-wider uppercase text-ink-soft hover:text-gold transition-colors text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => window.open('https://calendly.com/lispinruiz/nailappointment', '_blank')}
            className="whitespace-nowrap font-sans text-sm tracking-wider uppercase px-6 py-3 bg-gold text-white hover:bg-gold-dark transition-all duration-300 cursor-pointer text-center"
          >
            Book Now
          </button>
          <a
            href="https://www.instagram.com/nailstudiobydaniela"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-sans text-sm tracking-wider uppercase text-ink-soft hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line text-lg"></i>
            @nailstudiobydaniela
          </a>
        </div>
      )}
    </header>
  );
}
